import { EventMenu } from "@bryntum/schedulerpro";
import { PLUGINS_KEYS } from "../../other/constants/PluginKeys.jsx";
import { SwivuSchedulerMenuPluginMixin } from "./mixins/SwivuSchedulerMenuPluginMixin";
import { cellMenuItemAdjustPoints, entityCellTaskColor, entityCellTaskStyle } from "../../other/utils/gridCellMenuUtils.jsx";
import { buildTaskEntityColorMenu, buildTaskEntityStyleMenu } from "../../other/utils/utils.jsx";
import { checkIncentivePermission } from "@/other/utils/incentiveUtils.jsx";
import { INCENTIVE_PERMISSION_KEYS } from "@/other/constants/IncentiveKeys.jsx";

export default class SwivuSchedulerEventMenuPlugin extends SwivuSchedulerMenuPluginMixin(EventMenu) {

  static get $name() {
    return PLUGINS_KEYS.schedulerEventMenu;
  }

  static get pluginConfig() {
    return {
      chain: ["populateEventMenu"]
    };
  }

  populateEventMenu(event) {
    const { items } = event;
    const scheduler = this.client;

    const isHasClipboard = !scheduler.readOnly && scheduler.features.eventCopyPaste.hasClipboardData() !== false;
    const { pasteEvent, insertTask, replaceTask, addReminderOnEvent, taskFiles } = SwivuSchedulerEventMenuPlugin.itemsKeyRef;
    Object.assign(items, {
      [pasteEvent]: isHasClipboard && this.getPasteMenuItem(event, { weight: 10 }),
      [insertTask]: this.getScheduleTaskMenuItem(null, { weight: 20 }),
      [replaceTask]: this.getScheduleTaskMenuItem(event.eventRecord, { weight: 30 }),
      [taskFiles]: this.getTaskFilesMenuItem(event, { weight: 40 }),
      [addReminderOnEvent]: this.getAddReminderMenuItem(event, { weight: 50 }),
      [entityCellTaskColor]: buildTaskEntityColorMenu({item: entityCellTaskColor({ weight: 210 }), record: event.eventRecord.task, selectedItems: [event.eventRecord.task]}),
      [entityCellTaskStyle]: buildTaskEntityStyleMenu({item: entityCellTaskStyle({ weight: 220 }), record: event.eventRecord.task, selectedItems: [event.eventRecord.task]}),
      adjustPoints: { ...cellMenuItemAdjustPoints(), disabled: !checkIncentivePermission({ project: scheduler.project, permissionKey: INCENTIVE_PERMISSION_KEYS.INCENTIVE_MANAGERS })}
    });
  }
}
